import { FieldTemplateProps } from '@rjsf/utils';

import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import { filterErrorsForField } from 'dashboard/components/WorkflowControlPanel/StepConfigAction/rjsf/utils';
import { WorkflowErrorMessage } from 'dashboard/components/WorkflowControlPanel/useWorkflowError';
import Spacer from 'design-system/components/Spacer';

export function FieldTemplate({
  id,
  label,
  required,
  uiSchema,
  children,
  formContext,
}: FieldTemplateProps) {
  const formattedLabel = required ? `${label}*` : label;
  const errorsForField = filterErrorsForField(formContext.errorsForStep || [], id).map(
    (error) => error.message,
  );

  return (
    <>
      <ParamLabel labelText={formattedLabel} htmlFor={id} helpText={uiSchema?.['ui:help']} />
      {children}
      {errorsForField && errorsForField.length > 0 && (
        <WorkflowErrorMessage>{errorsForField[0]}</WorkflowErrorMessage>
      )}
      <Spacer height={2} />
    </>
  );
}
